module.exports = __webpack_public_path__ + "static/img/handCut.f7ad8643.png";